import { render, staticRenderFns } from "./DmarcSettings.vue?vue&type=template&id=d41aa0da&scoped=true"
import script from "./DmarcSettings.vue?vue&type=script&lang=js"
export * from "./DmarcSettings.vue?vue&type=script&lang=js"
import style0 from "./DmarcSettings.vue?vue&type=style&index=0&id=d41aa0da&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41aa0da",
  null
  
)

export default component.exports